class ProductCardSlider extends HTMLElement {
  constructor() {
    super();
    this.mediaContainer = null;
    this.progressBar = null;
    this.progressThumb = null;
    this.handleScroll = this.handleScroll.bind(this);
  }

  connectedCallback() {
    this.mediaContainer = this.querySelector('.product-card-media-container');
    this.progressBar = this.querySelector('.pc-progressbar');
    this.progressThumb = this.progressBar?.querySelector('.pc-progressbar__thumb');

    if (this.mediaContainer && this.progressThumb) {
      this.mediaContainer.addEventListener('scroll', this.handleScroll);
    }
  }

  disconnectedCallback() {
    if (this.mediaContainer && this.handleScroll) {
      this.mediaContainer.removeEventListener('scroll', this.handleScroll);
    }
  }

  handleScroll() {
    // Calculate proportional progress for any number of slides
    const scrollLeft = this.mediaContainer.scrollLeft;
    const maxScroll = this.mediaContainer.scrollWidth - this.mediaContainer.clientWidth;
    const progress = maxScroll > 0 ? (scrollLeft / maxScroll) * 100 : 0;

    this.progressThumb.style.transform = `translateX(${Math.min(progress, 100)}%)`;
  }
}

customElements.define('product-card-slider', ProductCardSlider);
